
import CheckSymptomsComponent from "@/components/RegisterTest/CheckSymptoms/CheckSymptomsComponent";
export default CheckSymptomsComponent;
